import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
export default class ClassifiedsActions extends Component {
  view() {
    const discussion = this.attrs.discussion;
    const owner = discussion.user?.();
    const me = app.session.user;
    const isMyListing = owner && me && owner.id() === me.id();
    return m("div", {
      className: "ClassifiedsActions"
    }, !isMyListing && me && m(Button, {
      className: "Button Button--primary ClassifiedsActions-primary",
      icon: "fas fa-comments",
      onclick: () => this.contactSeller()
    }, app.translator.trans('flarum-classifieds.forum.actions.contact_seller')), !isMyListing && !me && m(Button, {
      className: "Button Button--primary ClassifiedsActions-primary",
      icon: "fas fa-sign-in-alt",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('flarum-classifieds.forum.actions.login_to_contact')), isMyListing && m(Button, {
      className: "Button Button--primary ClassifiedsActions-primary",
      icon: "fas fa-pencil-alt",
      onclick: () => {
        import(/* webpackChunkName: 'forum/components/EditListingModal', webpackMode: 'lazy-once' */ './EditListingModal').then(m => {
          app.modal.show(m.default, {
            discussion
          });
        });
      }
    }, app.translator.trans('flarum-classifieds.forum.discussion_controls.edit_listing_button')), m("div", {
      className: "ClassifiedsActions-secondary"
    }, m("button", {
      type: "button",
      className: "Button Button--icon ClassifiedsActions-iconBtn",
      title: app.translator.trans('flarum-classifieds.forum.actions.share'),
      "aria-label": app.translator.trans('flarum-classifieds.forum.actions.share'),
      onclick: () => this.share()
    }, m("i", {
      className: "icon fas fa-share-alt",
      "aria-hidden": "true"
    })), m("button", {
      type: "button",
      className: "Button Button--icon ClassifiedsActions-iconBtn",
      title: app.translator.trans('flarum-classifieds.forum.actions.copy_link'),
      "aria-label": app.translator.trans('flarum-classifieds.forum.actions.copy_link'),
      onclick: () => this.copyLink()
    }, m("i", {
      className: "icon fas fa-link",
      "aria-hidden": "true"
    }))));
  }
  contactSeller() {
    const discussion = this.attrs.discussion;
    const owner = discussion.user?.();
    if (!owner) return;

    // If flarum/messages is enabled, open the message composer; otherwise jump
    // to the seller's profile so the user can DM/follow them via core flows.
    const messagesEnabled = !!app.extensionData?.['flarum-messages'] || !!app.forum.attribute?.('messagesEnabled');
    if (messagesEnabled && app.composer?.load) {
      flarum.reg.asyncModuleImport('flarum/messages/forum/components/MessageComposer').then(mod => {
        const Composer = mod.default || mod;
        app.composer.load(Composer, {
          user: app.session.user,
          recipients: [owner]
        });
        app.composer.show();
      }).catch(() => this.openSellerProfile(owner));
    } else {
      this.openSellerProfile(owner);
    }
  }
  openSellerProfile(owner) {
    const url = app.route?.user?.(owner) || `/u/${owner.username?.()}`;
    m.route.set(url);
  }
  share() {
    const discussion = this.attrs.discussion;
    const url = window.location.origin + app.route.discussion(discussion);
    const title = discussion.title();
    if (navigator.share) {
      navigator.share({
        title,
        url
      }).catch(() => this.copyLink());
    } else {
      this.copyLink();
    }
  }
  copyLink() {
    const discussion = this.attrs.discussion;
    const url = window.location.origin + app.route.discussion(discussion);
    navigator.clipboard?.writeText(url).then(() => {
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('flarum-classifieds.forum.actions.link_copied'));
    }).catch(() => {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('flarum-classifieds.forum.actions.copy_failed'));
    });
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ClassifiedsActions', ClassifiedsActions);flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/EditListingModal');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/utils/labelText');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/index');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/utils/uploadListingImage');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addListingComposer');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addListingControls');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addListingHeroBadge');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addPostTypes');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ClassifiedsActions');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ClassifiedsBreadcrumb');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ClassifiedsLandingPage');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/extend');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ClassifiedsListingCard');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addListingClass');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ClassifiedsSellerCard');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ListingImageUploader');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ListingComposerFields');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ListingStatusChangedPost');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/extendDiscussionModel');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/extendTagModel');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/extendUserModel');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addListingMeta');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/addClassifiedsDiscussionPageClass');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/utils/formatPrice');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ClassifiedsHeroCarousel');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'forum/components/ListingBumpedPost');
flarum.reg.addChunkModule('170', '46', 'ramon-classifieds', 'common/utils/labelClass');